import { completedSeqFlowPostfix } from '../../../../features/tracking/models/CompletedItemsStore';
import { PersistenceTrackingData, TrackingData } from '../clients/trackingClient';
import { TrackingIdentifier, tryRemoveSequencedFlowPostfix } from '@ael/core-api';
import {Guid} from '../../../model/guid';

export function persistedTrackingDataToTrackingData(
  trackingData: PersistenceTrackingData,
  convertToItemId: (trackingId: TrackingIdentifier) => Guid | null
): TrackingData {
  const finishedItemIds = trackingData.finishedItems
    .map((trackingId) => convertTrackingIdToItemId(trackingId, convertToItemId))
    .filter((x: Guid | null): x is Guid => x !== null)
    .toSet();
  return {
    finishedItems: finishedItemIds,
    widgetTrackingData: trackingData.widgetTrackingData,
    version: trackingData.version,
  };
}

function convertTrackingIdToItemId(
  trackingId: TrackingIdentifier,
  convertToItemId: (trackingId: TrackingIdentifier) => Guid | null
): Guid | null {
  const result = tryRemoveSequencedFlowPostfix(trackingId);
  if (result.wasRemoved) {
    const itemId = convertToItemId(result.trackingIdentifier);
    if (itemId !== null) {
      return itemId + completedSeqFlowPostfix;
    }
    return itemId;
  }
  return convertToItemId(trackingId);
}
